import { Card } from "./ui/card";
import PageTitle from "./typography/title";
import { AlertCircle } from "lucide-react";

export default function ErrorBoundary() {
  return (
    <div className="flex flex-col items-center justify-center h-screen w-screen">
      <Card className="p-6 w-2/3">
        <div className="flex flex-row items-center gap-4 text-destructive">
          <AlertCircle />
          <PageTitle>500 Erro Inesperado</PageTitle>
        </div>
        <p>Um erro desconhecido foi encontrado ao carregar esta página</p>
      </Card>
    </div>
  );
}
